var map = {
	"./N1.png": 460,
	"./N2.png": 461,
	"./N3.png": 462,
	"./N4.png": 463,
	"./N5.png": 464,
	"./N6.png": 465,
	"./N7.png": 466,
	"./S1.png": 467,
	"./S2.png": 468,
	"./S3.png": 469,
	"./ohne.png": 243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1815;